<template >
  <div class="info">
    <div class="breadcrumb-box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/super' }"
          >项目管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{pname}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first" class="first">
        <div class="form-box" v-if="activeName2 == 'first'">
          <el-form :label-position="'right'" label-width="120px" :model="form">
            <el-form-item label="项目ID：">
              <el-input v-model.trim="form.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="服务起止日期：">
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="form.serviceStartTime"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">~</el-col>
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="form.serviceEndTime"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="项目名称：">
              <el-input v-model.trim="form.projectName"></el-input>
            </el-form-item>
            <el-form-item label="负责人：">
              <el-input v-model.trim="form.personInCharge"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：">
              <el-input v-model.trim="form.concatNumber"></el-input>
            </el-form-item>
            <el-form-item label="装机容量：">
              <!-- <el-input v-model="form.declareCapacity"></el-input> -->
              <el-input v-model.trim="form.installedCapacity">
                <template slot="append">kVA</template>
              </el-input>
            </el-form-item>
            <el-form-item label="装报需量：">
              <el-input v-model.trim="form.declareCapacity">
                <template slot="append">kVA</template>
              </el-input>
            </el-form-item>
            <el-form-item label="电压等级：">
              <el-input v-model.trim="form.voltageLevel">
                <template slot="append">kV</template>
              </el-input>
            </el-form-item>
            <el-form-item label="计量方案：">
              <div>
                <el-form-item label="尖：" label-width="30px">
                <div>
                  <p  :key="k" v-for="(v,k) in price.jian"  > {{k==0?"全年":(k+"月")}}：<f :key="i" v-for="i in v" >{{i.startTime}}:00:00--{{i.endTime-1}}:59:59 / </f>
                  </p>
                </div>
                </el-form-item>
                <el-form-item label="峰：" label-width="30px">
                <div>
                  <p  :key="k" v-for="(v,k) in price.feng"  > {{k==0?"全年":(k+"月")}}：<f :key="i" v-for="i in v" >{{i.startTime}}:00:00--{{i.endTime-1}}:59:59 / </f>
                  </p>
                </div>
                </el-form-item>
                <el-form-item label="谷：" label-width="30px">
                <div>
                  <p  :key="k" v-for="(v,k) in price.gu"  > {{k==0?"全年":(k+"月")}}：<f :key="i" v-for="i in v" >{{i.startTime}}:00:00--{{i.endTime-1}}:59:59 / </f>
                  </p>
                </div>
                </el-form-item>
                <el-form-item label="平：" label-width="30px">
                <div>
                  <p  :key="k" v-for="(v,k) in price.ping"  > {{k==0?"全年":(k+"月")}}：<f :key="i" v-for="i in v" >{{i.startTime}}:00:00--{{i.endTime-1}}:59:59 / </f>
                  </p>
                </div>
                </el-form-item>
                
              
              </div>
            </el-form-item>
            <!-- <el-form-item label="项目图片：">
              <el-input v-model="form.projectIcon"></el-input>
            </el-form-item> -->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="upDate">确 定</el-button>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="设备管理" name="second">
        <shebei v-if="activeName2 == 'second'"></shebei>
      </el-tab-pane>
      <el-tab-pane label="网关配置" name="third">
        <wangguan
          v-if="activeName2 == 'third'"
          :rightIndex="activeName"
        ></wangguan>
      </el-tab-pane>
      <el-tab-pane label="设备配置" name="fourth">
        <shebeipeizhi v-if="activeName2 == 'fourth'"></shebeipeizhi>
      </el-tab-pane>
       <el-tab-pane label="电量计算" name="fifth">
        <powerBox v-if="activeName2 == 'fifth'" :pname="pname" :pid="id"></powerBox>
      </el-tab-pane>
      <el-tab-pane label="用户管理" name="six">
        <userManage2 v-if="activeName2 == 'six'"></userManage2>
      </el-tab-pane>
      <el-tab-pane label="topic配置" name="seven" class="first">
        <div class="form-box" v-if="activeName2 == 'seven'">
          <el-form :label-position="'right'" label-width="120px" :model="form">
            <el-form-item label="项目ID：">
              <el-input v-model="form.id" readonly></el-input>
            </el-form-item>
            <el-form-item label="服务起止日期：">
              {{ form.serviceStartTime }}~{{ form.serviceEndTime }}
            </el-form-item>
            <el-form-item label="项目名称：">
              <el-input readonly v-model="form.projectName"></el-input>
            </el-form-item>
            <el-form-item label="负责人：">
              <el-input readonly v-model="form.personInCharge"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：">
              <el-input readonly v-model="form.concatNumber"></el-input>
            </el-form-item>
            <el-form-item label="装机容量：">
              <!-- <el-input v-model="form.declareCapacity"></el-input> -->
              <el-input readonly v-model="form.installedCapacity">
                <template slot="append">kVA</template>
              </el-input>
            </el-form-item>
            <el-form-item label="装报需量：">
              <el-input readonly v-model="form.declareCapacity">
                <template slot="append">kVA</template>
              </el-input>
            </el-form-item>
            <el-form-item label="电压等级：">
              <el-input readonly v-model="form.voltageLevel">
                <template slot="append">kV</template>
              </el-input>
            </el-form-item>
            <el-form-item label="计量方案：">
              <div>
                 <el-form-item label="尖：" label-width="30px">
                <div>
                  <p  :key="k" v-for="(v,k) in price.jian"  > {{k==0?"全年":(k+"月")}}：<f :key="i" v-for="i in v" >{{i.startTime}}:00:00--{{i.endTime-1}}:59:59 / </f>
                  </p>
                </div>
                </el-form-item>
                <el-form-item label="峰：" label-width="30px">
                <div>
                  <p  :key="k" v-for="(v,k) in price.feng"  > {{k==0?"全年":(k+"月")}}：<f :key="i" v-for="i in v" >{{i.startTime}}:00:00--{{i.endTime-1}}:59:59 / </f>
                  </p>
                </div>
                </el-form-item>
                <el-form-item label="谷：" label-width="30px">
                <div>
                  <p  :key="k" v-for="(v,k) in price.gu"  > {{k==0?"全年":(k+"月")}}：<f :key="i" v-for="i in v" >{{i.startTime}}:00:00--{{i.endTime-1}}:59:59 / </f>
                  </p>
                </div>
                </el-form-item>
                <el-form-item label="平：" label-width="30px">
                <div>
                  <p  :key="k" v-for="(v,k) in price.ping"  > {{k==0?"全年":(k+"月")}}：<f :key="i" v-for="i in v" >{{i.startTime}}:00:00--{{i.endTime-1}}:59:59 / </f>
                  </p>
                </div>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="topic：">
              <el-input v-model="topic"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="upTopic">确 定</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>

import {
  Message
} from 'element-ui';
import wangguan from "../../components/super/wangguan";
import shebei from "../../components/super/shebei";
import userManage2 from "../../components/super/userManage2";
import powerBox from "../../components/super/powerBox";
import shebeipeizhi from "../../components/super/shebeipeizhi";
export default {
  data() {
    return {
      activeName: "first",
      activeName2: "first",
      topic: "",
      form: {
        serviceStartTime: "",
        serviceEndTime: "",
        concatNumber: "",
        declareCapacity: "",
        installedCapacity: "",
        personInCharge: "",
        projectCode: "",
        projectIcon: "",
        projectName: "",
        // topic: "",
        voltageLevel: "",
        dataType: "1",
      },
      price:{
        jian: {},
        feng: {},
        gu: {},
        ping: {}
      },
      id: "",
      // pname:""
    };
  },
  components: {
    wangguan,
    userManage2,
    shebei,
    powerBox,
    shebeipeizhi,
  },
  created() {
    this.id = this.$route.params.id;
    this.pname=this.$getCookie('projectName');
    this.getProjectDetail();
  },
  methods: {
    getProjectDetail() {
      this.$http
        .post("bma-user-service/project/searchProjectDetail", {
          projectId: this.id,
        })
        .then((res) => {
          this.form = res.data;
          this.topic = res.data.topic;
        });

        this.$http
        .post("bma-distribution-service/electricPrice/searchElectricPriceList", {
          projectId: this.id,
        })
        .then((res) => {
          
          for(var d in res.data){
            var dd = res.data[d];
            if(dd.electricType == 1){
              if(!this.price.jian[dd.effectMonth]){
                this.price.jian[dd.effectMonth]=[]
              }
              
              this.price.jian[dd.effectMonth].push(dd)
            }else if(dd.electricType == 2){
             if(!this.price.feng[dd.effectMonth]){
                this.price.feng[dd.effectMonth]=[]
              }
              this.price.feng[dd.effectMonth].push(dd)
            }else if(dd.electricType == 3){
              if(!this.price.gu[dd.effectMonth]){
                this.price.gu[dd.effectMonth]=[]
              }
              this.price.gu[dd.effectMonth].push(dd)
            }else if(dd.electricType == 4){
              if(!this.price.ping[dd.effectMonth]){
                this.price.ping[dd.effectMonth]=[]
              }
              this.price.ping[dd.effectMonth].push(dd)
            }
          }
          this.price = JSON.parse(JSON.stringify(this.price))
          console.log(this.price)
        });
    },
    upDate() {
      console.log(this.form);
      let flag = false;
      if (!this.form.serviceStartTime) flag = true;
      if (!this.form.serviceEndTime) flag = true;
      if (!this.form.concatNumber) flag = true;
      if (!this.form.personInCharge) flag = true;
      if (!this.form.installedCapacity) flag = true;
      if (!this.form.declareCapacity) flag = true;
      if (!this.form.voltageLevel) flag = true;
      if (flag) {
        Message.warning("请填写必要信息");
        return;
      }
      this.form.dataType = "1";
      this.$http
        .post("bma-user-service/project/updateProject", this.form)
        .then((res) => {
          if (res.code == 200) {
            Message.success("修改成功");
          }
        });
    },
    // 更新topic内容
    upTopic() {
      this.$http
        .post("bma-user-service/project/updateProjectTopic", {
          projectId: this.id,
          topic: this.topic,
        })
        .then((res) => {
          if (res.code == 200) {
            Message.success("修改成功");
          }
        });
    },
    handleClick() {
      console.log(this.activeName);
      this.activeName2 = "temp";
      this.$nextTick(() => {
        this.activeName2 = this.activeName;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.info {
  margin-top: 10px;
  padding-top: 20px;
  background: rgba(248, 248, 249, 1);
  .breadcrumb-box {
    background: #f8f8f9;
    padding: 0 20px;
    margin-bottom: 20px;
  }
  .el-breadcrumb {
  }
  /deep/.el-tabs {
    .el-tabs__header {
      padding-left: 20px;
    }
  }
  .first {
    .form-box {
      width: 540px;
      height: 820px;
      .line {
        text-align: center;
      }
    }
    .el-button {
      margin-left: 120px;
    }
  }
  #pane-third {
    background: #ececec;
    padding: 10px;
  }
  #pane-fourth {
    background: #ececec;
    padding: 10px;
  }
  #pane-fifth {
    background: #ececec;
    padding: 10px;
  }
}
</style>